"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Role = void 0;
/**
 * User Role
 */
var Role;
(function (Role) {
    Role["NOTIFIED_ADMIN"] = "notified_admin";
    Role["NOTIFIED_HOST"] = "notified_host";
    Role["NOTIFIED_SPEAKER"] = "notified_speaker";
    Role["NOTIFIED_VIEWER"] = "notified_viewer";
})(Role = exports.Role || (exports.Role = {}));
